/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { ChangeDefaultBankAccountConflictCurrentDefaultBankAccountDto } from '../../src/model';
// @ts-ignore
import type { ChangeDefaultBankAccountConflictNewDefaultBankAccountDto } from '../../src/model';
// @ts-ignore
import type { ChangeDefaultBankAccountInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { ChangeDefaultBankAccountOkDto } from '../../src/model';
// @ts-ignore
import type { ChangeDefaultBankAccountReqBodyDto } from '../../src/model';
// @ts-ignore
import type { DeleteBankAccountByBankAccountUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { DeleteBankAccountByBankAccountUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { DeleteBankAccountByBankAccountUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetBankAccountsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetBankAccountsOkDto } from '../../src/model';
// @ts-ignore
import type { GetDefaultBankAccountInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetDefaultBankAccountNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetDefaultBankAccountOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PostBankAccountConflictDto } from '../../src/model';
// @ts-ignore
import type { PostBankAccountCreatedDto } from '../../src/model';
// @ts-ignore
import type { PostBankAccountForbiddenDto } from '../../src/model';
// @ts-ignore
import type { PostBankAccountInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostBankAccountNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PostBankAccountReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostBankAccountServiceUnavailableDto } from '../../src/model';
/**
 * BankAccountApi - axios parameter creator
 * @export
 */
export const BankAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 기본 계좌 설정
         * @param {ChangeDefaultBankAccountReqBodyDto} changeDefaultBankAccountReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerChangeDefaultBankAccount: async (changeDefaultBankAccountReqBodyDto: ChangeDefaultBankAccountReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeDefaultBankAccountReqBodyDto' is not null or undefined
            assertParamExists('bankAccountControllerChangeDefaultBankAccount', 'changeDefaultBankAccountReqBodyDto', changeDefaultBankAccountReqBodyDto)
            const localVarPath = `/bank-account/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeDefaultBankAccountReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 계좌 삭제
         * @param {string} bankAccountUuid 계좌 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerDeleteBankAccountByBankAccountUuid: async (bankAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankAccountUuid' is not null or undefined
            assertParamExists('bankAccountControllerDeleteBankAccountByBankAccountUuid', 'bankAccountUuid', bankAccountUuid)
            const localVarPath = `/bank-account/{bankAccountUuid}`
                .replace(`{${"bankAccountUuid"}}`, encodeURIComponent(String(bankAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 내 보유 계좌 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerGetBankAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bank-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 기본 계좌 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerGetDefaultBankAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bank-account/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 계좌 등록
         * @param {PostBankAccountReqBodyDto} postBankAccountReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerPostBankAccount: async (postBankAccountReqBodyDto: PostBankAccountReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postBankAccountReqBodyDto' is not null or undefined
            assertParamExists('bankAccountControllerPostBankAccount', 'postBankAccountReqBodyDto', postBankAccountReqBodyDto)
            const localVarPath = `/bank-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postBankAccountReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankAccountApi - functional programming interface
 * @export
 */
export const BankAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 기본 계좌 설정
         * @param {ChangeDefaultBankAccountReqBodyDto} changeDefaultBankAccountReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankAccountControllerChangeDefaultBankAccount(changeDefaultBankAccountReqBodyDto: ChangeDefaultBankAccountReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeDefaultBankAccountOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountControllerChangeDefaultBankAccount(changeDefaultBankAccountReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountApi.bankAccountControllerChangeDefaultBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 계좌 삭제
         * @param {string} bankAccountUuid 계좌 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankAccountControllerDeleteBankAccountByBankAccountUuid(bankAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountControllerDeleteBankAccountByBankAccountUuid(bankAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountApi.bankAccountControllerDeleteBankAccountByBankAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 내 보유 계좌 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankAccountControllerGetBankAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBankAccountsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountControllerGetBankAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountApi.bankAccountControllerGetBankAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 기본 계좌 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankAccountControllerGetDefaultBankAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDefaultBankAccountOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountControllerGetDefaultBankAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountApi.bankAccountControllerGetDefaultBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 계좌 등록
         * @param {PostBankAccountReqBodyDto} postBankAccountReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankAccountControllerPostBankAccount(postBankAccountReqBodyDto: PostBankAccountReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostBankAccountCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountControllerPostBankAccount(postBankAccountReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountApi.bankAccountControllerPostBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BankAccountApi - factory interface
 * @export
 */
export const BankAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankAccountApiFp(configuration)
    return {
        /**
         * 
         * @summary 기본 계좌 설정
         * @param {BankAccountApiBankAccountControllerChangeDefaultBankAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerChangeDefaultBankAccount(requestParameters: BankAccountApiBankAccountControllerChangeDefaultBankAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeDefaultBankAccountOkDto> {
            return localVarFp.bankAccountControllerChangeDefaultBankAccount(requestParameters.changeDefaultBankAccountReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 계좌 삭제
         * @param {BankAccountApiBankAccountControllerDeleteBankAccountByBankAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerDeleteBankAccountByBankAccountUuid(requestParameters: BankAccountApiBankAccountControllerDeleteBankAccountByBankAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bankAccountControllerDeleteBankAccountByBankAccountUuid(requestParameters.bankAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 내 보유 계좌 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerGetBankAccounts(options?: RawAxiosRequestConfig): AxiosPromise<GetBankAccountsOkDto> {
            return localVarFp.bankAccountControllerGetBankAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 기본 계좌 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerGetDefaultBankAccount(options?: RawAxiosRequestConfig): AxiosPromise<GetDefaultBankAccountOkDto> {
            return localVarFp.bankAccountControllerGetDefaultBankAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 계좌 등록
         * @param {BankAccountApiBankAccountControllerPostBankAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountControllerPostBankAccount(requestParameters: BankAccountApiBankAccountControllerPostBankAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostBankAccountCreatedDto> {
            return localVarFp.bankAccountControllerPostBankAccount(requestParameters.postBankAccountReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bankAccountControllerChangeDefaultBankAccount operation in BankAccountApi.
 * @export
 * @interface BankAccountApiBankAccountControllerChangeDefaultBankAccountRequest
 */
export interface BankAccountApiBankAccountControllerChangeDefaultBankAccountRequest {
    /**
     * 
     * @type {ChangeDefaultBankAccountReqBodyDto}
     * @memberof BankAccountApiBankAccountControllerChangeDefaultBankAccount
     */
    readonly changeDefaultBankAccountReqBodyDto: ChangeDefaultBankAccountReqBodyDto
}

/**
 * Request parameters for bankAccountControllerDeleteBankAccountByBankAccountUuid operation in BankAccountApi.
 * @export
 * @interface BankAccountApiBankAccountControllerDeleteBankAccountByBankAccountUuidRequest
 */
export interface BankAccountApiBankAccountControllerDeleteBankAccountByBankAccountUuidRequest {
    /**
     * 계좌 uuid
     * @type {string}
     * @memberof BankAccountApiBankAccountControllerDeleteBankAccountByBankAccountUuid
     */
    readonly bankAccountUuid: string
}

/**
 * Request parameters for bankAccountControllerPostBankAccount operation in BankAccountApi.
 * @export
 * @interface BankAccountApiBankAccountControllerPostBankAccountRequest
 */
export interface BankAccountApiBankAccountControllerPostBankAccountRequest {
    /**
     * 
     * @type {PostBankAccountReqBodyDto}
     * @memberof BankAccountApiBankAccountControllerPostBankAccount
     */
    readonly postBankAccountReqBodyDto: PostBankAccountReqBodyDto
}

/**
 * BankAccountApi - object-oriented interface
 * @export
 * @class BankAccountApi
 * @extends {BaseAPI}
 */
export class BankAccountApi extends BaseAPI {
    /**
     * 
     * @summary 기본 계좌 설정
     * @param {BankAccountApiBankAccountControllerChangeDefaultBankAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    public bankAccountControllerChangeDefaultBankAccount(requestParameters: BankAccountApiBankAccountControllerChangeDefaultBankAccountRequest, options?: RawAxiosRequestConfig) {
        return BankAccountApiFp(this.configuration).bankAccountControllerChangeDefaultBankAccount(requestParameters.changeDefaultBankAccountReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 계좌 삭제
     * @param {BankAccountApiBankAccountControllerDeleteBankAccountByBankAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    public bankAccountControllerDeleteBankAccountByBankAccountUuid(requestParameters: BankAccountApiBankAccountControllerDeleteBankAccountByBankAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return BankAccountApiFp(this.configuration).bankAccountControllerDeleteBankAccountByBankAccountUuid(requestParameters.bankAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 내 보유 계좌 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    public bankAccountControllerGetBankAccounts(options?: RawAxiosRequestConfig) {
        return BankAccountApiFp(this.configuration).bankAccountControllerGetBankAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 기본 계좌 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    public bankAccountControllerGetDefaultBankAccount(options?: RawAxiosRequestConfig) {
        return BankAccountApiFp(this.configuration).bankAccountControllerGetDefaultBankAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 계좌 등록
     * @param {BankAccountApiBankAccountControllerPostBankAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    public bankAccountControllerPostBankAccount(requestParameters: BankAccountApiBankAccountControllerPostBankAccountRequest, options?: RawAxiosRequestConfig) {
        return BankAccountApiFp(this.configuration).bankAccountControllerPostBankAccount(requestParameters.postBankAccountReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

